/*
 * @Author: Json Chen
 * @Date: 2021-06-25 14:07:11
 * @LastEditTime: 2021-06-30 17:21:45
 * @LastEditors: Json Chen
 * @Description: Price Tier 添加和编辑弹窗  priceTierIndex === -1 是添加, priceTierIndex >= 0 是要编辑的项的索引
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Product/Components/PriceTierModalForm.tsx
 */

import React from 'react';
import { Form, Input, Modal } from 'antd';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import InputMaxLength from '@/src/pages/Settings/Components/InputMaxLength';
import useResetFormOnCloseModal from '@/src/hooks/useResetFormOnCloseModal';
import ShowExistValue from './ShowExistValue';
import styles from '../style.module.less';
import { get } from 'lodash';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const PriceTierModalForm = ({
  visible,
  onConfirm,
  onCancel,
  priceTierDefaultCurrency,
  priceTierCurrencyOptions,
  priceTierList,
  priceTierIndex,
}: {
  // 弹窗是否展示
  visible: boolean;
  // 关闭弹窗
  onCancel: () => void;
  // 默认的currency
  priceTierDefaultCurrency: string;
  // 默认的 currency options 列表
  priceTierCurrencyOptions: { name: string; code: string }[];
  priceTierList: any;
  priceTierIndex: number;
  onConfirm: any;
}) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const [form] = Form.useForm();
  const [modalTitle, setModalTitle] = React.useState<string>('');
  const [confirmDisable, setConfirmDisable] = React.useState<boolean>(false);
  useResetFormOnCloseModal({
    form,
    visible,
  });

  const onOk = () => {
    form.validateFields().then((res) => {
      onConfirm(res);
    });
  };

  React.useEffect(() => {
    if (visible) {
      const defaultData = priceTierList[priceTierIndex];
      if (defaultData) {
        form.setFieldsValue(defaultData);
        setModalTitle(getI18n('storeProductSetting.detail.editPriceTier'));
      } else {
        form.setFieldsValue({
          title: `${getI18n('storeProductSetting.detail.priceTier')} ${
            priceTierList.length + 1
          }`,
          currencyCode: priceTierDefaultCurrency,
          remarks: '',
        });
        setModalTitle(getI18n('storeProductSetting.detail.addNewPriceTier'));
      }
    }
  }, [visible]);

  return (
    <Modal
      forceRender={true}
      title={modalTitle}
      visible={visible}
      okButtonProps={{
        disabled: confirmDisable,
      }}
      okText={getI18n('general.confirm')}
      cancelText={getI18n('general.cancel')}
      maskClosable={false}
      onOk={onOk}
      onCancel={onCancel}>
      <Form
        form={form}
        layout='vertical'
        name='priceTierModalForm'
        className={styles.priceTierModalForm}>
        <Form.Item
          name='title'
          className={styles.input}
          labelCol={{
            span: 24,
          }}
          label={
            <div className={styles.inputLabel}>
              <div className={styles.inputLableTitle}>
                {getI18n('storeProductSetting.detail.priceTierTitle')}*
              </div>
              <InputMaxLength maxLength={50} fieldName='title' />
            </div>
          }
          rules={[
            { required: true },
            {
              validator: (_, value) => {
                const hasSame = priceTierList
                  .filter((p, i) =>
                    // 过滤掉自己 , 可以和自己重复
                    priceTierIndex === -1 ? true : priceTierIndex !== i,
                  )
                  .some((p) => p.title === value);
                setConfirmDisable(hasSame);
                return hasSame
                  ? Promise.reject(
                      new Error(
                        'A price tier already exists with the same title.',
                      ),
                    )
                  : Promise.resolve();
              },
            },
          ]}>
          <Input
            size='large'
            placeholder='Repetitive price tier title'
            maxLength={50}
          />
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(p, c) => {
            const cT = get(c, 'currencyCode');
            const pT = get(p, 'currencyCode');
            return cT !== pT;
          }}>
          {(f) => {
            const { getFieldValue } = f;
            const v = getFieldValue('currencyCode');

            const fv = `${v} (Reporting Currency)`;

            return priceTierIndex !== -1 ? (
              <ItemWrapper
                title={`${getI18n(
                  'storeProductSetting.detail.priceTierCurrency',
                )}*`}>
                <ShowExistValue value={fv} />
              </ItemWrapper>
            ) : (
              <Form.Item
                name='currencyCode'
                className={styles.select}
                label={
                  <div className={styles.selectLabel}>
                    <div className={styles.selectLabelTitle}>
                      {`${getI18n(
                        'storeProductSetting.detail.priceTierCurrency',
                      )}*`}
                    </div>
                  </div>
                }
                rules={[{ required: true }]}>
                <SelectObjectAsValue
                  options={priceTierCurrencyOptions.map((o) => ({
                    label: o.name,
                    value: o.code,
                  }))}
                />
              </Form.Item>
            );
          }}
        </Form.Item>

        <Form.Item
          name='remarks'
          className={styles.input}
          label={
            <div className={styles.inputLabel}>
              <div className={styles.inputLableTitle}>
                {getI18n('storeProductSetting.detail.priceTierRemarks')} (
                {getI18n('general.optional')})
              </div>
              <InputMaxLength maxLength={100} fieldName='remarks' />
            </div>
          }>
          <Input.TextArea maxLength={100} size='large' />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PriceTierModalForm;
